import React from 'react'
import { Dimensions, Platform, View, Image, ViewStyle } from 'react-native'
import {
  iconAccuracyCircle,
  iconFlashProfile,
  iconLeaderboardCircle,
  iconTrendingUpOn,
} from '../../assets'
import { Skeleton } from '../skeleton'
import { Card } from '../card'
import { color } from '../../theme'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'

import { observer } from 'mobx-react-lite'
const recall = require('./iconRecall.png')
const leaderboardPointsIcon = require('./leaderboardPoints.png')
// @ts-ignore
import webRecall from './web_recall.png'
// @ts-ignore
import leaderboardPointsPng from './leaderboardPoints.png'
import { useTranslation } from 'react-i18next'
import { roundNumber, useStores } from '@trivie/core'

interface ProfileCardsProps {
  stats: any
  leaderboardData?: any
  levelAndPoints: any
  loadingRecall?: boolean
  loadingStats?: boolean
  leaderboardsEnabled?: boolean
  hideQuizzes?: boolean
  hideLeaderboard?: boolean
  enterpriseTier?: boolean
  style?: ViewStyle
}
export const ProfileCards = observer((props: ProfileCardsProps) => {
  const {
    style,
    leaderboardsEnabled,
    loadingRecall,
    stats,
    leaderboardData,
    hideQuizzes = false,
    hideLeaderboard = false,
  } = props

  const { userStore } = useStores()
  const { enterpriseTier } = userStore

  const { t } = useTranslation()

  return loadingRecall ? (
    <Skeleton style={LOADER} />
  ) : (
    <View style={{ ...style }}>
      {!leaderboardsEnabled && !hideLeaderboard && (
        <View style={CONTAINER}>
          <Card style={{ ...STAT_PANEL, justifyContent: 'center', paddingLeft: 0 }}>
            <View style={{ top: 3, marginRight: 15 }}>
              {Platform.OS === 'web' ? (
                <img src={webRecall} height={28} width={28} />
              ) : (
                <Image source={recall} style={{ height: 28, width: 28 }} />
              )}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text
                text={`${roundNumber(stats?.overall_recall * 100 || 0)}%`}
                variant="titleEmphasized"
              />
              <Text
                tx="Profile.recall"
                variant="body2Emphasized"
                style={{ color: color.shade50 }}
              />
            </View>
          </Card>
        </View>
      )}
      {!hideQuizzes && (
        <View style={CONTAINER}>
          <Card style={{ ...STAT_PANEL, marginRight: 15 }}>
            <View style={{ top: 3, right: 6 }}>
              <SvgIcon src={iconFlashProfile} size={32} viewBox="0 0 32 32" />
            </View>
            <View style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Text text={stats?.quiz_count || '0'} variant="titleEmphasized" />
              <Text
                numberOfLines={1}
                tx="Quiz.quizzes"
                variant="body2Emphasized"
                style={{ color: color.shade50 }}
              />
            </View>
          </Card>
          {loadingRecall ? (
            <Skeleton style={{ ...LOADER, height: 68, width: 160 }} />
          ) : (
            <Card style={STAT_PANEL}>
              <SvgIcon src={iconAccuracyCircle} size={32} viewBox="0 0 32 32" />
              <View style={{ display: 'flex', flexDirection: 'column', marginLeft: 11 }}>
                <Text text={`${Math.round(stats?.pct_correct * 100)}%`} variant="titleEmphasized" />
                <Text
                  tx="Profile.accuracy"
                  variant="body2Emphasized"
                  style={{ color: color.shade50 }}
                />
              </View>
            </Card>
          )}
        </View>
      )}

      {leaderboardsEnabled && !hideLeaderboard && (
        <View style={{ ...CONTAINER, marginBottom: 15 }}>
          <Card style={{ ...STAT_PANEL, marginRight: 15 }}>
            <View style={{ right: 6 }}>
              <SvgIcon src={iconLeaderboardCircle} size={32} viewBox="0 0 32 32" />
            </View>
            <View
              style={{
                flexDirection: 'column',
                marginLeft: 4,
                flexWrap: 'nowrap',
                flex: 1,
              }}
            >
              <Text
                text={leaderboardData?.rank ? `#${leaderboardData?.rank}` : '-'}
                variant="titleEmphasized"
              />
              <Text
                tx="Leaderboard.header"
                variant="body2Emphasized"
                numberOfLines={1}
                style={{ color: color.shade50 }}
              />
            </View>
          </Card>
          {!enterpriseTier ? (
            <Card style={STAT_PANEL}>
              <View style={{ top: 3 }}>
                {Platform.OS === 'web' ? (
                  <img src={leaderboardPointsPng} height={28} width={28} />
                ) : (
                  <Image source={leaderboardPointsIcon} style={{ height: 28, width: 28 }} />
                )}
              </View>
              <View style={{ display: 'flex', flexDirection: 'column', marginLeft: 11 }}>
                <Text text={leaderboardData?.points || '-'} variant="titleEmphasized" />
                <Text
                  tx={t('Common.points')}
                  variant="body2Emphasized"
                  style={{ color: color.shade50 }}
                />
              </View>
            </Card>
          ) : (
            <Card style={STAT_PANEL}>
              <View style={{ top: 3 }}>
                {Platform.OS === 'web' ? (
                  <img src={webRecall} height={28} width={28} />
                ) : (
                  <>
                    {Platform.OS === 'android' ? (
                      <SvgIcon src={iconTrendingUpOn} color={color.blue} size={32} />
                    ) : (
                      <Image source={recall} style={{ height: 28, width: 28 }} />
                    )}
                  </>
                )}
              </View>
              <View style={{ display: 'flex', flexDirection: 'column', marginLeft: 11 }}>
                <Text
                  text={`${roundNumber(stats?.overall_recall * 100 || 0)}%`}
                  variant="titleEmphasized"
                />
                <Text
                  tx="Profile.recall"
                  variant="body2Emphasized"
                  style={{ color: color.shade50 }}
                />
              </View>
            </Card>
          )}
        </View>
      )}
    </View>
  )
})

const STAT_PANEL: ViewStyle = {
  borderRadius: 20,
  height: 68,
  backgroundColor: '#fff',
  width: 160,
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: 16,
  paddingLeft: 16,
  paddingBottom: 16,
  paddingVertical: 12,
  flex: 1,
  borderWidth: 2,
  borderColor: '#F3F2F1',
  justifyContent: 'flex-start',
  //@ts-ignore
  cursor: 'default',
}
const CONTAINER: ViewStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: 15,
}
const LOADER: ViewStyle = {
  borderRadius: 20,
  marginBottom: 16,
  width: Platform.OS === 'web' ? 720 : Dimensions.get('screen').width - 40,
  height: 151,
}
